module.exports = __webpack_public_path__ + "static/media/46.737f6603.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/46.jpg
// module id = 736
// module chunks = 0